export const GadgetSystemDominionId = "gadget/dominion/system";
export const GadgetCurrentAppDominionId = "gadget/dominion/current-app";
export const ShopifyDominionId = "shopify/dominion/shopify";
